import LogsHelper from 'Flow2/components/Article/Helpers/LogsHelper';

class StoreHelper {

    static saveStoreData({ articleObjects, updateArticleObjects, updateArticleMetadata, data, autoSave }) {
        let updatedObj = null;
        const { articleViewFields, articleElements } = articleObjects;
        if (articleElements.id && articleElements.id == data.id && articleElements[`changedElements`]) {
            updatedObj = { ...articleElements[`changedElements`] }
        }
        if (articleViewFields.id && articleViewFields.id == data.id && articleViewFields[`changedFields`]) {
            if (updatedObj) updatedObj = { ...updatedObj, ...articleViewFields[`changedFields`] };
            else updatedObj = { ...articleViewFields[`changedFields`] };
        }
        if (updatedObj) {
            //20231017  updateArticleMetadata({ id: data.id, metadata: updatedObj });
            updateArticleObjects({ articleViewFields: {}, articleElements: {} });
            LogsHelper.setEditLogsAction({ id: data.id, updateArticleMetadata, metadata: updatedObj, autoSave });
            return true;
        }
        return false;
    }

    static checkAndUpdateDataObj({ updateDataObjects, mainObj, subObjName, name, value }) {
        if (subObjName && mainObj[`${subObjName}`].popUpObjects) {
            updateDataObjects({
                [`${subObjName}`]: {
                    ...mainObj[`${subObjName}`],
                    [`current${name}`]: value,
                    popUpObjects: {
                        ...mainObj[`${subObjName}`].popUpObjects,
                        [`${name}`]: value
                    }
                }
            });
        } else {
            updateDataObjects({
                [`${subObjName}`]: {
                    ...mainObj[`${subObjName}`],
                    [`current${name}`]: value,
                    popUpObjects: { [`${name}`]: value }
                }
            });
        }
    }
}

export default StoreHelper;